import React, { useState, useEffect } from "react";
import { Button, Form, InputGroup, Modal, Spinner } from "react-bootstrap";
import AddIcon from "@mui/icons-material/Add";
import { TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useCookies } from "react-cookie";
import { configOrganizationSubmit } from "ServerAPI/serverAPI";
import TanstackTable from "components/elements/advance-table/TanstackTable";
import editIcon from "../../assets/images/add-course/edit.svg";
import RefreshButton from "components/elements/refresh-button/RefreshButton";
import { useToast } from "context/toast-context/ToastProvider";
// import deleteIcon from "../../assets/images/add-course/delete.svg";
// import ConfirmationDialog from "components/Dialog/ConfirmationDialog";

const Process = ({
  allProcessess,
  setAllProcessess,
  fetchOrganisationDetails,
  allDepartments,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredProcessess, setFilteredProcessess] = useState(allProcessess);
  const [showModal, setShowModal] = useState(false);
  const [domainName, setDomainName] = useState("");
  const [editIndex, setEditIndex] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  // const [deleteIndex, setDeleteIndex] = useState(null);
  const [cookies] = useCookies();
  const { showToast } = useToast();
  useEffect(() => {
    setFilteredProcessess(
      allProcessess.filter((process) =>
        process.title.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, allProcessess]);

  const handleSearchChange = (e) => setSearchTerm(e.target.value);

  const handleShowModal = () => {
    setDomainName("");
    setEditIndex(null);
    setShowModal(true);
  };

  const handleEdit = (index) => {
    setEditIndex(index);
    setDomainName(filteredProcessess[index].title);
    setShowModal(true);
  };

  // const handleDeleteClick = (index) => {
  //   setDeleteIndex(index);
  //   setOpenConfirmationDialog(true);
  // };

  // const handleDeleteConfirm = () => {
  //   setAllProcessess((prev) => prev.filter((_, i) => i !== deleteIndex));
  //   setOpenConfirmationDialog(false);
  // };

  const handleSave = async () => {
    if (domainName.trim() === "") {
      alert("Domain name is required!");
      return;
    }

    let updatedProcesses = [...allProcessess];
    if (editIndex !== null) {
      updatedProcesses[editIndex] = {
        ...updatedProcesses[editIndex],
        title: domainName,
        // createdDate: allProcessess[editIndex].createdDate
      };
    } else {
      const newProcess = {
        title: domainName,
        // new: true,
        createdDate: new Date().toISOString(),
      };
      updatedProcesses.push(newProcess);
    }
    // setAllProcessess(updatedProcesses);
    setIsSubmitting(true);

    const payload = {
      email: cookies.email,
      department: allDepartments,
      roleId: cookies.roleId,
      organizationId: String(cookies.organizationId),
      userId: cookies.userId,
      domain: updatedProcesses,
    };
    try {
      const response = await configOrganizationSubmit(payload);
      if (response?.status === 200) {
        showToast("Domain added", "success");
        fetchOrganisationDetails();
      } else {
        showToast("Something went wrong", "error");
      }
    } catch (error) {
      showToast(error?.response?.data?.message, "error");
      console.error("Error saving domain:", error);
    } finally {
      setIsSubmitting(false);
      setShowModal(false);
    }
  };

  const handleRefresh = () => {
    fetchOrganisationDetails();
  };

  const columns = [
    {
      header: () => (
        <span style={{ fontWeight: "bold", color: "#224D99" }}>SN</span>
      ),
      accessorKey: "sn",
      cell: (info) => info.row.index + 1,
    },
    {
      header: () => (
        <span style={{ fontWeight: "bold", color: "#224D99" }}>Domain</span>
      ),
      accessorKey: "title",
    },
    {
      header: () => (
        <span style={{ fontWeight: "bold", color: "#224D99" }}>
          Created Date
        </span>
      ),
      accessorKey: "createdDate",
      cell: (info) =>
        info.getValue() ? new Date(info.getValue()).toLocaleDateString() : "-",
    },
    {
      header: () => (
        <span style={{ fontWeight: "bold", color: "#224D99" }}>Actions</span>
      ),
      accessorKey: "actions",
      cell: ({ row }) => (
        <>
          <img
            src={editIcon}
            className="cursor-pointer mx-2"
            alt="editIcon"
            onClick={() => handleEdit(row.index)}
          />
          {/* <img src={deleteIcon} className="cursor-pointer" alt="deleteIcon" onClick={() => handleDeleteClick(row.index)} /> */}
        </>
      ),
    },
  ];

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <InputGroup className="w-50">
          <TextField
            size="small"
            variant="outlined"
            placeholder="Search for domain"
            InputProps={{ startAdornment: <SearchIcon /> }}
            onChange={handleSearchChange}
            className="mb-2"
          />
        </InputGroup>
        <div className="d-flex align-items-center gap-4">
          <RefreshButton handleRefresh={handleRefresh} title="Refresh Domain" />
          <Button variant="primary" onClick={handleShowModal}>
            <AddIcon /> Add
          </Button>
        </div>
      </div>

      <TanstackTable columns={columns} data={filteredProcessess} pagination />

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "rgba(34, 75, 153, 1)" }}>
            {editIndex !== null ? "Edit Details" : "Add Domain"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Domain Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter Domain Name"
              value={domainName}
              onChange={(e) => setDomainName(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowModal(false)}
            style={{
              backgroundColor: "transparent",
              color: "rgba(34, 75, 153, 1)",
            }}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSave}
            disabled={isSubmitting}
          >
            {isSubmitting ? <Spinner size="sm" animation="border" /> : "Save"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* <ConfirmationDialog
        open={openConfirmationDialog}
        handleClose={() => setOpenConfirmationDialog(false)}
        handleConfirm={handleDeleteConfirm}
        message="Are you sure you want to delete this domain?"
      /> */}
    </>
  );
};

export default Process;
